import type { KnownCurrency } from '@/lib/types';
import { getChainConfig } from './contracts';

export interface TokenConfig {
  readonly symbol: KnownCurrency;
  readonly address: string;
  readonly decimals: number;
  /** USDT requires approve-to-zero before setting a new allowance */
  readonly requiresApproveReset: boolean;
}

export function getTokenConfigs(): ReadonlyMap<KnownCurrency, TokenConfig> {
  const cfg = getChainConfig();
  return new Map([
    ['USDC', { symbol: 'USDC', address: cfg.tokenAddresses.USDC, decimals: 6, requiresApproveReset: false }],
    ['USDT', { symbol: 'USDT', address: cfg.tokenAddresses.USDT, decimals: 6, requiresApproveReset: true }],
  ]);
}

/** Reverse lookup: on-chain token address → currency symbol */
export function currencyFromAddress(address: string): KnownCurrency {
  for (const [currency, config] of getTokenConfigs()) {
    if (config.address.toLowerCase() === address.toLowerCase()) return currency;
  }
  throw new Error(`Unknown token address: ${address}`);
}
